import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '../services/translation-service';
import { SessionService } from '../auth/session-service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private readonly sessionService = inject(SessionService);
  private readonly router = inject(Router);
  private translationService = inject(TranslationService);
  private translateService = inject(TranslateService);

  canActivate(): boolean | UrlTree {
    const urlLang = this.translationService.currentLangOnStandard(this.translateService);
    if (this.sessionService.isAppAuthenticated()) {
      return true;
    }

    return this.router.createUrlTree([`/${urlLang}/login`]);
  }
}
